import React from "react";

interface LogoDisplayProps {
	url: string;
	tenantId: string;
}

export function LogoDisplay({url, tenantId}: LogoDisplayProps) {
	return (
		<div
			style={{
				width: "150px",
				height: "80px",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
			}}
		>
			<img
				style={{height: "100%", width: "100%", padding: "8px", objectFit: "contain"}}
				alt={tenantId}
				src={url}
			/>
		</div>
	);
}
